export interface IBankAccountViewModel {
    approvals: IBankAccountApproval[],
    approvalsNeeded: number,
    approvalsOutstanding: number,
    bankAccountName: string,
    bankAccountNumber: string,
    bankId: number,
    bankName: string,
    beneficiaryDetails: IInstructionBeneficiaryViewModel,
    createdBy: number,
    currency?: any,
    currencyCode: string,
    investorEntityId: number,
    investorEntityName: string,
    isDefault: boolean,
    isInternational: boolean,
    isVerified: boolean,
    reference: string,
    status: BankAccountStatus,
    statusName: string,
    visibility?: BankAccountVisibility,
    visibilityName: string
}

export interface IInstructionBeneficiaryViewModel
{
    BankAccountName: string,
    BankAccountNumber: string,
    BankName: string,
    Swift: string,
    BankClearingCode: string,
    BeneficiaryCountryCode: string|number,
    BeneficiaryCountryCodeName: string,
    BeneficiaryName: string,
    BeneficiaryAddress1: string,
    BeneficiaryAddress2: string,
    BeneficiaryAddress3: string,
    PayCorrespondentBankfees?: boolean
    BankSortCode: string,
    Intermediary: string,
    IBAN: string,
}

export enum BankAccountVisibility
{
    Visible = 0,
    Hidden = 1
}

export enum BankAccountStatus
{
    Active = 0,
    Hidden = 1,
    Inactive = 2,
    ReviewRequired = 3,
    ApprovalRequired = 4,
    Rejected = 5,
    Cancelled = 6
}
export interface IBankAccountResponse{
    data: IBankAccountViewModel [],
    loading: boolean,
    error: boolean
}

export interface IBankAccountActionResponse{
    loading: boolean,
    error: boolean
}

export interface IBankAccountApproval {
    bankAccountApprovalId: number,
    bankAccountId: number, 
    approvedByUserEntityId: number, 
    date: Date,
    isApproved: boolean
}

export interface BankAccountPermissionsResponse {
    loading: boolean, 
    error: boolean,
    data: Map<number,boolean>
}